import OnMountIsLoadedMixin from '@/mixins/on-mount-is-loaded';
import { IPostbackUserMessageContent } from '@/models/bot-models';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class UserPostbackMessage extends OnMountIsLoadedMixin {
    @Prop({ default: () => ({}) }) public content!: IPostbackUserMessageContent;
}
